import React, { useState } from 'react';
import { apis, models } from "@vote4dance/judging-sdk";
import { Typography, Space, message, notification, Button, Divider, Alert } from 'antd';
import { Link, useParams } from "react-router-dom";
import { Localization, _T } from "../../../../base-react/src/Localization";
import { getApiUrl } from "../../../../base-react/scripts/cdn";
var Api = apis.Api;
import DataUpload from './components/DataUpload';
import { ImportTeamsModal } from './components/ImportTeams';
import { CSVToArray } from './utilities';
var CompetitionSource = models.competitions.CompetitionsSource;
import { useCompetition } from '../../../../base-react/hooks/Competition';
import { CompetitionStatus } from '@vote4dance/judging-schema';
import { DownloadOutlined } from '@ant-design/icons';
import { ButtonConfirm } from '../../../../base-react/components/ButtonConfirm';
import { Loading } from '../../../../base-react/components/Loading';
const { Text, Title } = Typography;
export const DataTransfer = () => {
    let { competition_id } = useParams();
    const [inputCompetition, event, competitions, loading, , canEdit] = useCompetition(competition_id);
    const [isLoading, setIsLoading] = useState(false);
    const [importCompare, setImportCompare] = useState();
    const [importClasses, setImportClasses] = useState([]);
    const [importTeams, setImportTeams] = useState([]);
    const [open, setOpen] = useState(false);
    const onData = (data) => {
        var teams = [];
        var classes = [];
        var classXref = {};
        const normalizeField = (value) => {
            if (value == undefined) {
                return undefined;
            }
            const trimmed = String(value).trim();
            return trimmed.length ? trimmed : undefined;
        };
        var lines = data.split(/\r\n|\n|\r/);
        var headers = undefined, headerCount = 0;
        var class_label = undefined;
        var delimiter = undefined;
        for (var i in lines) {
            var line = lines[i];
            if (!line.length) {
                continue;
            }
            if (headers == undefined) {
                if (line.trim()[0] == '#') {
                    continue;
                }
                var headerFields = undefined;
                [';', ',', '\t'].forEach(delim => {
                    var candidateFields = CSVToArray(line, delim)[0];
                    if (headerFields == undefined || candidateFields.length > headerFields.length) {
                        headerFields = candidateFields;
                        delimiter = delim;
                    }
                });
                const isEnglish = headerFields.indexOf('Class name') >= 0;
                headers = {
                    class_label: headerFields.indexOf(isEnglish ? 'Class name' : 'Klassrubrik'),
                    start_number: headerFields.indexOf(isEnglish ? 'Startnr' : 'Startnr'),
                    placement: headerFields.indexOf(isEnglish ? 'Plac' : 'Plac'),
                    up: headerFields.indexOf(isEnglish ? 'Points' : 'UP'),
                    name_1: headerFields.indexOf(isEnglish ? 'Name 1' : 'Namn 1'),
                    name_2: headerFields.indexOf(isEnglish ? 'Name 2' : 'Namn 2'),
                    name_3: headerFields.indexOf(isEnglish ? 'Name 3' : 'Namn 3'),
                    org: headerFields.indexOf(isEnglish ? 'Club' : 'Klubb'),
                    class_name: headerFields.indexOf(isEnglish ? 'Original class' : 'Klass'),
                    starting_in: headerFields.indexOf(isEnglish ? 'Starting class' : 'Startar i'),
                    starting_round: headerFields.indexOf(isEnglish ? 'Starting round' : 'Startande runda'),
                    warning: headerFields.indexOf(isEnglish ? 'Warning' : 'Varning'),
                    note: headerFields.indexOf(isEnglish ? 'Note' : 'Notering'),
                    org_1: headerFields.indexOf(isEnglish ? 'Club 1' : 'Klubb 1'),
                    org_2: headerFields.indexOf(isEnglish ? 'Club 2' : 'Klubb 2'),
                    org_3: headerFields.indexOf(isEnglish ? 'Club 3' : 'Klubb 3'),
                    license_1: headerFields.indexOf('Lic 1'),
                    license_2: headerFields.indexOf('Lic 2'),
                    license_3: headerFields.indexOf('Lic 3'),
                    person_id_1: headerFields.indexOf('Person-ID 1'),
                    person_id_2: headerFields.indexOf('Person-ID 2'),
                    person_id_3: headerFields.indexOf('Person-ID 3'),
                    year_1: headerFields.indexOf(isEnglish ? 'Year 1' : decodeURIComponent('F%C3%B6dd 1')),
                    year_2: headerFields.indexOf(isEnglish ? 'Year 2' : decodeURIComponent('F%C3%B6dd 2')),
                    year_3: headerFields.indexOf(isEnglish ? 'Year 3' : decodeURIComponent('F%C3%B6dd 3')),
                    org_full: headerFields.indexOf(isEnglish ? 'Complete clubs' : decodeURIComponent('Fullst%C3%A4ndiga klubbnamn')),
                    show_name: headerFields.indexOf(isEnglish ? 'Show name' : 'Shownamn'),
                    country: headerFields.indexOf(isEnglish ? 'Country' : 'Land')
                };
                headerCount = headerFields.length;
                continue;
            }
            if (line[0] == delimiter) {
                lines[i] = line = '0' + line;
            }
            var fields = CSVToArray(line, delimiter)[0];
            // class label header
            const classLabelField = normalizeField(fields[headers.class_label]);
            if (classLabelField != undefined && classLabelField !== '0' && classLabelField.trim().length > 0) {
                class_label = classLabelField;
                continue;
            }
            // handle broken name fields (newline inside a quoted field)
            const quoteCount = (line.match(/"/g) || []).length;
            if (fields.length < headerCount && (quoteCount % 2 === 1)) {
                lines[parseInt(i) + 1] = line.concat('"' + delimiter + '"').concat(lines[parseInt(i) + 1]);
                continue;
            }
            var name_3 = undefined;
            if (fields.length > headerCount) {
                name_3 = fields[headers.name_2];
                fields.splice(headers.name_2 + 1, 1);
            }
            var class_name = normalizeField(fields[headers.starting_in]);
            if (class_name == undefined || class_name.length == 0) {
                class_name = normalizeField(fields[headers.class_name]);
                headers.starting_in = headers.class_name;
            }
            if (class_name != undefined && !classXref.hasOwnProperty(class_name)) {
                var newClass = {
                    class_name: class_name,
                    class_label: class_label
                };
                classes.push(newClass);
                classXref[class_name] = newClass;
            }
            var newTeam = {
                team_start_number: normalizeField(fields[headers.start_number]),
                team_placement: normalizeField(fields[headers.placement]),
                team_up: normalizeField(fields[headers.up]),
                team_name_1: normalizeField(fields[headers.name_1]),
                team_name_2: normalizeField(fields[headers.name_2]),
                team_name_3: normalizeField(name_3 || fields[headers.name_3]),
                team_org: normalizeField(fields[headers.org]),
                team_org_full: normalizeField(fields[headers.org_full]),
                team_class: normalizeField(fields[headers.class_name]),
                team_starting_in: normalizeField(fields[headers.starting_in]),
                team_starting_round: normalizeField(fields[headers.starting_round]),
                team_warning: normalizeField(fields[headers.warning]),
                team_note: normalizeField(fields[headers.note]),
                team_org_1: normalizeField(fields[headers.org_1]),
                team_org_2: normalizeField(fields[headers.org_2]),
                team_org_3: normalizeField(fields[headers.org_3]),
                team_license_1: normalizeField(fields[headers.license_1]),
                team_license_2: normalizeField(fields[headers.license_2]),
                team_license_3: normalizeField(fields[headers.license_3]),
                team_person_id_1: normalizeField(fields[headers.person_id_1]),
                team_person_id_2: normalizeField(fields[headers.person_id_2]),
                team_person_id_3: normalizeField(fields[headers.person_id_3]),
                team_year_1: normalizeField(fields[headers.year_1]),
                team_year_2: normalizeField(fields[headers.year_2]),
                team_year_3: normalizeField(fields[headers.year_3]),
                team_show_name: normalizeField(fields[headers.show_name]),
                team_country: normalizeField(fields[headers.country])
            };
            if (fields[headers.start_number] == undefined || (String(fields[headers.start_number]).length == 0)) {
                newTeam.team_start_number = 0;
            }
            if (fields[headers.placement] != undefined && (fields[headers.placement].toLowerCase() == 's')) {
                newTeam.team_cancelled = 1;
            }
            else {
                newTeam.team_cancelled = 0;
            }
            teams.push(newTeam);
        }
        setImportClasses(classes);
        setImportTeams(teams);
        importTeamsAPI(true, null, classes, teams);
    };
    const importTeamsAPI = (preview, checked, classes, teams) => {
        setIsLoading(true);
        Api.call(`${CompetitionSource.url}/${competition_id}`, 'import-teams', {
            classes: classes ? classes : importClasses,
            teams: teams ? teams : importTeams,
            preview: preview,
            checked: checked
        }).then((response) => {
            setImportCompare(response);
            setOpen(true);
            setIsLoading(false);
            if (!preview) {
                notification.success({
                    message: _T('data.import.success')
                });
            }
        }).catch((err) => {
            message.error(err.message);
            setIsLoading(false);
        });
    };
    const onPressReset = async (done) => {
        await Api.call(`${CompetitionSource.url}/${competition_id}`, 'reset-results', {}).catch((err) => {
            message.error(err.message);
        });
        done();
    };
    const onPressDelete = async (done) => {
        await Api.call(`${CompetitionSource.url}/${competition_id}`, 'delete-teams', {}).catch((err) => {
            message.error(err.message);
        });
        done();
    };
    const disableDownload = inputCompetition && ![CompetitionStatus.Closed, CompetitionStatus.Archived].includes(inputCompetition.competition_status);
    const disableReset = inputCompetition && inputCompetition.competition_status != CompetitionStatus.Private;
    const content = loading ? React.createElement(Loading, null) :
        React.createElement(Space, { orientation: "vertical" },
            React.createElement(Title, { level: 2 }, _T('data.import.title')),
            React.createElement(DataUpload, { onData: onData, loading: isLoading, disabled: !canEdit }),
            React.createElement(Divider, null),
            React.createElement(Title, { level: 2 }, _T('data.export.title')),
            disableDownload &&
                React.createElement(Alert, { title: _T('data.export.status'), type: "warning", showIcon: true }),
            React.createElement(Link, { to: getApiUrl('results/' + Localization.getLanguage() + '/' + (inputCompetition === null || inputCompetition === void 0 ? void 0 : inputCompetition.competition_id) + '.csv') },
                React.createElement(Button, { type: "primary", icon: React.createElement(DownloadOutlined, null), disabled: disableDownload }, _T('data.export.csv'))),
            React.createElement(Link, { to: getApiUrl('partial-average/' + (inputCompetition === null || inputCompetition === void 0 ? void 0 : inputCompetition.competition_id) + '-partial-average.csv') },
                React.createElement(Button, { type: "dashed", icon: React.createElement(DownloadOutlined, null) }, _T('data.export.partial'))),
            React.createElement(Divider, null),
            React.createElement(Title, { level: 2 }, _T('data.reset.title')),
            React.createElement(Text, { type: "secondary" }, _T('data.reset.info')),
            disableReset &&
                React.createElement(Alert, { title: _T('data.reset.status'), type: "warning", showIcon: true }),
            React.createElement(ButtonConfirm, { title: _T('data.reset.title'), description: _T('data.reset.confirm'), onConfirm: onPressReset, buttonProps: {
                    danger: true,
                    disabled: disableReset || !canEdit
                } }),
            React.createElement(Divider, null),
            React.createElement(Title, { level: 2 }, _T('data.delete.title')),
            React.createElement(Text, { type: "secondary" }, _T('data.delete.info')),
            React.createElement(Alert, { title: _T('data.delete.status'), type: "warning", showIcon: true }),
            React.createElement(ButtonConfirm, { title: _T('data.delete.title'), description: _T('data.delete.confirm'), onConfirm: onPressDelete, buttonProps: {
                    danger: true,
                    disabled: !canEdit
                } }));
    return (React.createElement(React.Fragment, null,
        content,
        React.createElement(ImportTeamsModal, { open: open, competition_id: competition_id, importCompare: importCompare, onImport: (checked) => importTeamsAPI(false, checked), onClose: () => setOpen(false) })));
};
